export enum ButtonAction {
    CONFIRM = "Confirm",
    CANCEL = "Cancel",
    ACCEPT_APPLICATION="Accept bursary application",
    APPROVE_APPLICATION="Approve bursary application",
    VIEW_INVOICES = "View invoice/s",
    UPLOAD_INVOICES = "Upload invoice/s",
    NEXT = "Next",
    VIEW = "View",
    DELETE = "Delete",
    AMEND = "Amend",
    UPDATE = "Update",
    SAVE = `Save`,
    CLOSE = "Close",
    CHECK= "Check",
    DOWNLOAD= "Download",
    ACTIONS = "Actions",
    ADDENDUM = "Addendum",
    APPLYTORENEW = "Apply for renewal of funding",
    SAVE_STUDENT_INFO = `Save student information`,
    CONFIRMSTUDENTDETAILS = "Confirm student details",
    ADDNEWCANDIDATES = "+ Add new candidate",
    BACK = "Back",
    SAVEFORLATER = "Save for later",
    SUBMIT = "Submit",
    CONTINUE = "Continue",
    MOVEFUNDS = "Move funds",
    VIEW_EVENT_DETAILS = "View event details",
    ADD_NEW_LOCATION = "+ Add new location",
    CREATE_EVENT = "Create event",
    ADD_INVITEES = `Add invitees`,
    UPDATE_INVITEES = `Update invitees`,
    CANCEL_EVENT = "Cancel event",
    EDIT_EVENT = "Edit event details",
    ADDINVITEES = "Add invitees",
    UPDATE_EVENT = "Update event details",
    CONTINUE_EVENT_CREATION = "Continue",
    EDIT_RSVP = "Edit RSVP",
    RSVP = "RSVP",
    ADD_PROFILE_PICTURE = "Upload photo",
    UPLOAD = "Upload",
    ADD_EVENT_IMAGE = "Add event image",
    AMEND_BURSARY_AMOUNT = "Amend bursary amount",
    DECLINE = "Decline",
    APPLY_TO_RENEW_FUNDING = "APPLY TO RENEW FUNDING",
    TERMINATE_BURSARY = "TERMINATE BURSARY",
    NUDGE_EXECUTIVE = "Nudge Executive",
    REQUEST_CHANGES = "SEND BACK FOR UPDATES",
    ADD_UNIVERSITY = "+ Add University",
    EDIT_DEPARTMENT = "Edit department",
    DELETE_DEPARTMENT = "Delete department",
    ENABLE_DEPARTMENT = "Enable department",
    DISABLE_DEPARTMENT = "Disable department",
    EDIT_USER = "Edit user details",
    DELETE_USER = "Delete user",
    DOWNLOAD_DOCUMENT = "Download document",
    UPDATE_DOCUMENT = "Update document"
}
